<ng-container *transloco="let t; read: 'blog-import-from-pojects'">
  <h1>{{ t("title") }}</h1>
  <section class="article">
    <article>
      <div class="text">
        <div [innerHTML]="t('content_1')"></div>
        <img src="assets/import_menu.png" style="width: 600px" />
        <div [innerHTML]="t('content_2')"></div>
        <img src="assets/import_struct.png" style="width: 600px" />
        <div [innerHTML]="t('content_3')"></div>
      </div>
    </article>
  </section>
</ng-container>
